export function request(options = {}, context = {}) {
  return Promise.resolve({NOT_YET_IMPLEMENTED: true}) 
}

export default request


// WEBPACK FOOTER //
// ./src/data-sources/npm-stats.js